// The enterKeyHint prop is present in React 17+; this type provides it inline
// for backwards compatibility with React 16

function arrayIsEqual(arr, other) {
  if (arr.length !== other.length) {
    return false;
  }
  return arr.every((el, index) => el === other[index]);
}
function setIsEqual(a, b) {
  return a.size === b.size && [...a].every(x => b.has(x));
}
function formatBytes(bytes) {
  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let unitIndex = 0;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size = size / 1024;
    unitIndex++;
  }
  size = Math.round(size * 100) / 100;
  return `${size} ${units[unitIndex]}`;
}

/**
 * The base set of props that are available on all inputs.
 * Also includes ClassNameProps, TagProps, and EnterKeyHintProps.
 * @param Key Additional props from HTMLInputElement to include.
 * @example StandardInputProps<'value' | 'onChange' | 'min' | 'max'>
 */

export { arrayIsEqual, formatBytes, setIsEqual };
